import React, { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import ScrollKeeper from "./ScrollKeeper";
import CopilotWidget from "../CopilotWidget";
import DemoOverlay from "../DemoOverlay";
import { Toaster } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { UserCheck, LogOut } from "lucide-react";

function ImpersonationBanner() {
  const { user, isImpersonating, exitImpersonation } = useAuth();
  if (!isImpersonating) return null;
  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium" data-testid="impersonation-banner">
      <UserCheck size={16} />
      You are currently logged in as <span className="font-bold">{user?.name}</span>
      {user?.impersonator && <span className="text-white/80">(by {user.impersonator.name})</span>}
      <button onClick={() => exitImpersonation().then(() => (window.location.href = "/users"))}
        data-testid="exit-impersonation" className="ml-2 inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 rounded-full px-3 py-0.5 transition-colors">
        <LogOut size={13} /> Exit
      </button>
    </div>
  );
}

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-white">
      <ScrollKeeper />
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="flex-1 min-w-0 flex flex-col">
        <DemoOverlay />
        <ImpersonationBanner />
        <TopBar onMobileMenu={() => setMobileOpen(true)} />
        <main data-testid="app-main" className="flex-1 max-w-[1600px] w-full mx-auto px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
          <div className="animate-fade-up">
            {/* Keep sidebar + top bar on screen while the next screen's code loads */}
            <Suspense fallback={<div className="min-h-[50vh] flex items-center justify-center text-slate-400 text-sm" data-testid="page-loader">Loading…</div>}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
      <Toaster position="top-right" richColors closeButton />
      <CopilotWidget />
    </div>
  );
}
